module.exports = __webpack_public_path__ + "static/bottom-d6ffa276609f4a4ebcf771cddb245855.png";